<template lang="pug">
  div
    .fixed.w-full.v-full.bg-gray-900.top-0.right-0.p-5.flex.justify-start.header(class="md:pl-10")
      .pt-1(class="sm:ml-6 md:ml-48")
        a(@click="logPdEvent('Header', 'User clicked Pipedream logo')" href="https://pipedream.com" target="_blank")
          PipedreamLogo(height="20")
      .ml-auto(class="md:w-1/8 sm:flex-wrap")
        a.text-sm.font-bold(@click="logPdEvent('Header', 'User clicked Docs link')" href="https://github.com/PipedreamHQ/pipedream" target="_blank") Github
      .ml-6(class="md:w-1/8 sm:flex-wrap")
        a.text-sm.font-bold(@click="logPdEvent('Header', 'User clicked Docs link')" href="https://docs.pipedream.com" target="_blank") Docs
      .ml-6(class="sm:mr-6 md:mr-48 md:w-1/8 sm:flex-wrap")
        a.text-sm.font-bold(@click="logPdEvent('Header', 'User clicked Community link')" href="https://pipedream.com/community" target="_blank") Community
    .bg-grey-lighter.max-w-5xl.mx-auto.mt-24(class="md:mt-24")
      .ml-10.mr-10
        Twitter.mx-auto.mt-8.mb-6(height="150px")
        .max-w-4xl.mx-auto.mb-6
          h2.mb-3.text-5xl.font-extrabold.title(class="md:text-6xl") Twitter Workflow Automation
        .max-w-2xl.mx-auto.mb-3
          h3.text-xl.mb-16 Patterns for processing streams of tweets and interacting with the Twitter API
      .max-w-5xl.mx-auto.text-left.ml-10.mr-10
        .flex.flex-wrap.justify-around.justify-center.mt-10.m-1(class="md:flex-no-wrap")
          .max-w-md.rounded.m-1.bg-gray-800(class="md:w-1/3") 
            a(href="#example-workflows" @click="logPdEvent('Sections', 'User clicked Example Workflows Section')")
              .w-full.h-full.p-6
                .text-center.mx-auto.mb-5
                  PipedreamIcon.mr-3.inline(width="40px" height="40px")
                h3.text-xl.font-semibold.text-center.mb-4 Example Workflows
                p.text-lg.mb-4.text-center Send tweets to Discord or SQS, trigger a Lambda, run SQL on tweets, and more
          .max-w-md.rounded.m-1.bg-gray-800(class="md:w-1/3") 
            a(href="#twitter-event-streams" @click="logPdEvent('Sections', 'User clicked Getting Started Section')")
              .w-full.h-full.p-6
                .text-center.mx-auto.mb-5
                  Twitter.mr-3.inline(width="40px" height="40px")
                h3.text-xl.font-semibold.text-center.mb-4 Twitter Event Sources
                p.text-lg.mb-4.text-center Trigger code on new tweets, followers, likes, etc.
          .max-w-md.rounded.m-1.bg-gray-800(class="md:w-1/3") 
            a(href="#apis" @click="logPdEvent('Sections', 'User clicked APIs section')")
              .w-full.h-full.p-6
                .text-center.mx-auto.mb-5
                  Terminal.mr-3.inline(width="40px" height="40px" fill="#ffffff")
                h3.text-xl.font-semibold.text-center.mb-4 SSE + REST API
                p.text-lg.mb-4.text-center Process tweets in real time using a private SSE stream, or in batch using a REST API
      p.mb-24(id="example-workflows")
      .max-w-5xl.mx-auto.text-left.ml-10.mr-10.text-xl
        p.text-green.text-3xl.font-bold.mb-3 Example Workflows
        h3.mb-6 Workflows are linear sequences of steps &mdash; just Node.js code &mdash;
          span.ml-1 hosted and run by Pipedream.
        h3.mb-6 
          span.font-bold You can copy the workflows below and run them in your Pipedream account
            a.text-blue-500.font-bold.ml-1(href="https://docs.pipedream.com/pricing/" target="_blank") for free
            | .
          span.ml-1 They run code on new tweets and interact with the Twitter API in creative ways. You can modify or extend them in any way you'd like,
          a.text-blue-500.ml-1.mr-1(href="https://docs.pipedream.com/workflows/steps/code/" target="_blank") running your own Node code
          span.mr-1 or using
          a.text-blue-500.mr-1(href="https://docs.pipedream.com/workflows/steps/actions/" target="_blank") pre-built functions
          | to connect to
          a.text-blue-500.ml-1(href="https://docs.pipedream.com/apps/all-apps/" target="_blank") 200+ integrated apps
          | .
        h3.mb-6 On copy, you'll be asked to create a
          a.text-blue-500.mr-1.ml-1(href="#getting-started") Twitter event source
          | that triggers your workflow on new tweets matching your target search.
        h3.mb-6 A single Twitter source can trigger multiple workflows. If you already created a source you want to use as a trigger, click
          span.font-bold.mr-1.ml-1 Select Another Trigger
          | near the bottom-left of the source selector.
        .flex.flex-wrap.justify-around.justify-center.mt-10.m-1(class="md:flex-no-wrap")
          .max-w-md.rounded.m-1.bg-gray-800(class="md:w-1/2 sm:w-full") 
            a(href="https://pipedream.com/@dylan/twitter-to-email-p_zACral/readme" target="_blank" @click="logPdEvent('Workflows', 'Twitter to Email')")
              .w-full.h-full.p-10
                .text-center.mx-auto.-mt-4.mb-2
                  Twitter.inline(width="70px" height="70px")
                  ArrowRight.mr-3.inline.white(width="25px" height="25px")
                  Mail.inline(height="40px" width="40px")
                h3.text-xl.font-semibold.text-center.mb-4 Twitter to Email
                p.text-lg.mb-4.text-center Sends an email on new tweets
          .max-w-md.rounded.m-1.bg-gray-800(class="md:w-1/2 sm:w-full") 
            a(href="https://pipedream.com/@dylan/send-an-http-post-request-on-new-tweets-p_6lCRoN/readme" target="_blank" @click="logPdEvent('Workflows', 'Twitter to Webhook')")
              .w-full.h-full.p-10
                .text-center.mx-auto.-mt-4.mb-2
                  Twitter.inline(width="70px" height="70px")
                  ArrowRight.mr-3.inline.white(width="25px" height="25px")
                  Webhook.inline(height="40px" width="40px" fill="#ffffff")
                h3.text-xl.font-semibold.text-center.mb-4 Twitter to Webhook
                p.text-lg.mb-4.text-center Send an HTTP POST request with the tweet in the payload, to a URL you specify
        .flex.flex-wrap.justify-around.justify-center.m-1(class="md:flex-no-wrap")
          .max-w-md.rounded.m-1.bg-gray-800(class="md:w-1/2 sm:w-full") 
            a(href="https://pipedream.com/@dylan/twitter-to-aws-sqs-p_vQCraZ/readme" target="_blank" @click="logPdEvent('Workflows', 'Twitter to SQS')")
              .w-full.h-full.p-10
                .text-center.mx-auto.-mt-4.mb-2
                  Twitter.inline(width="70px" height="70px")
                  ArrowRight.mr-3.inline.white(width="25px" height="25px")
                  SQS.inline(height="40px" width="40px")
                h3.text-xl.font-semibold.text-center.mb-4 Twitter to AWS SQS
                p.text-lg.mb-4.text-center Send new tweets to an SQS queue
          .max-w-md.rounded.m-1.bg-gray-800(class="md:w-1/2 sm:w-full") 
            a(href="https://pipedream.com/@dylan/twitter-to-aws-eventbridge-event-bus-p_ZJCWpg/readme" target="_blank" @click="logPdEvent('Workflows', 'Twitter to EventBridge')")
              .w-full.h-full.p-10
                .text-center.mx-auto.-mt-4.mb-2
                  Twitter.inline(width="70px" height="70px")
                  ArrowRight.mr-3.inline.white(width="25px" height="25px")
                  EventBridge.inline(height="40px" width="40px")
                h3.text-xl.font-semibold.text-center.mb-4 Twitter to AWS EventBridge
                p.text-lg.mb-4.text-center Send new tweets to an event bus
        .flex.flex-wrap.justify-around.justify-center.m-1(class="md:flex-no-wrap")
          .max-w-md.rounded.m-1.bg-gray-800(class="md:w-1/2 sm:w-full") 
            a(href="https://pipedream.com/@dylan/twitter-to-aws-lambda-p_wOCAdP/readme" target="_blank" @click="logPdEvent('Workflows', 'Twitter to Lambda')")
              .w-full.h-full.p-10
                .text-center.mx-auto.-mt-4.mb-2
                  Twitter.inline(width="70px" height="70px")
                  ArrowRight.mr-3.inline.white(width="25px" height="25px")
                  Lambda.inline(height="40px" width="40px")
                h3.text-xl.font-semibold.text-center.mb-4 Twitter to AWS Lambda
                p.text-lg.mb-4.text-center Invoke a Lambda function for every new tweet using the AWS SDK
          .max-w-md.rounded.m-1.bg-gray-800(class="md:w-1/2 sm:w-full") 
            a(href="https://pipedream.com/@dylan/twitter-to-telegram-p_QPC8JP/readme" target="_blank" @click="logPdEvent('Workflows', 'Twitter to Telegram')")
              .w-full.h-full.py-6.px-10
                .text-center.mx-auto.mb-2
                  Twitter.inline(width="70px" height="70px")
                  ArrowRight.mr-3.inline.white(width="25px" height="25px")
                  Telegram.inline(height="40px" width="40px")
                h3.text-xl.font-semibold.text-center.mb-4 Twitter to Telegram
                p.text-lg.mb-4.text-center Sends tweets to Telegram
        .flex.flex-wrap.justify-around.justify-center.m-1(class="md:flex-no-wrap")
          .max-w-md.rounded.m-1.bg-gray-800(class="md:w-1/2 sm:w-full") 
            a(href="https://pipedream.com/@pravin/twitter-mentions-slack-p_dDCA5e/edit" target="_blank" @click="logPdEvent('Workflows', 'Twitter to Slack')")
              .w-full.h-full.py-6.px-10
                .text-center.mx-auto.-mt-2.mb-2
                  Twitter.ml-6.inline(width="70px" height="70px")
                  ArrowRight.inline.white(width="25px" height="25px")
                  Slack.-ml-2.inline(height="80px" width="80px")
                h3.text-xl.font-semibold.text-center.mb-4 Twitter to Slack
                p.text-lg.mb-4.text-center Sends a formatted tweet to Slack
          .max-w-md.rounded.m-1.bg-gray-800(class="md:w-1/2 sm:w-full") 
            a(href="https://pipedream.com/@dylan/twitter-to-discord-p_MOCQ9Y/readme" target="_blank" @click="logPdEvent('Workflows', 'Twitter to Discord')")
              .w-full.h-full.p-10
                .text-center.mx-auto.-mt-4.mb-2
                  Twitter.inline(width="70px" height="70px")
                  ArrowRight.mr-3.inline.white(width="25px" height="25px")
                  Discord.inline(height="50px" width="50px")
                h3.text-xl.font-semibold.text-center.mb-4 Twitter to Discord
                p.text-lg.mb-4.text-center Sends tweets to Discord
        .flex.flex-wrap.justify-around.justify-center.m-1(class="md:flex-no-wrap")
          .max-w-md.rounded.m-1.bg-gray-800(class="md:w-1/2 sm:w-full") 
            a(href="https://pipedream.com/@dylan/twitter-to-s3-p_KwCZGA/readme" target="_blank" @click="logPdEvent('Workflows', 'Twitter to Telegram')")
              .w-full.h-full.py-6.px-10
                .text-center.mx-auto.mb-2
                  Twitter.inline(width="70px" height="70px")
                  ArrowRight.mr-3.inline.white(width="25px" height="25px")
                  S3.inline(height="40px" width="40px")
                h3.text-xl.font-semibold.text-center.mb-4 Twitter to S3
                p.text-lg.mb-4.text-center Saves tweets in an Amazon S3 bucket
          .max-w-md.rounded.m-1.bg-gray-800(class="md:w-1/2 sm:w-full") 
            a(href="https://pipedream.com/@dylan/twitter-to-pipedream-sql-service-p_brCMA9/readme" target="_blank" @click="logPdEvent('Workflows', 'Twitter to Google Sheets')")
              .w-full.h-full.p-10
                .text-center.mx-auto.-mt-4.mb-2
                  Twitter.inline(width="70px" height="70px")
                  ArrowRight.inline.white.mr-3(width="25px" height="25px")
                  SQL.inline(height="40px" width="40px")
                h3.text-xl.font-semibold.text-center.mb-4 Twitter to SQL
                p.text-lg.mb-4.text-center Stores tweets in Pipedream's SQL service, allowing you to run queries on them
      p.mb-24(id="twitter-event-streams")
      .max-w-5xl.mx-auto.text-left.ml-10.mr-10.text-xl
        p.text-green.text-3xl.font-bold.mb-3 Twitter Event Sources
        p.mb-6 Pipedream
          a.text-blue-500.ml-1.mr-1(href="https://docs.pipedream.com/event-sources/" target="_blank") event sources
          | emit Twitter events in real time: tweets, follows, likes, and more. Sources can trigger
          a.text-blue-500.ml-1.mr-1(href="#example-workflows") Pipedream workflows
          | , and can be accessed via
          a.text-blue-500.ml-1(href="#apis") SSE or REST APIs
          | .
        p.mb-6 Click on a source below to get started.
        .flex.flex-wrap.justify-around.justify-center.m-1(class="md:flex-no-wrap")
          .max-w-md.rounded.m-1.bg-gray-800(class="md:w-1/2 sm:w-full") 
            a(href="https://pipedream.com/sources?action=create&url=https%3A%2F%2Fgithub.com%2FPipedreamHQ%2Fpipedream%2Fblob%2Fmaster%2Fcomponents%2Ftwitter%2Fsearch-twitter.js&app=twitter" target="_blank" @click="logPdEvent('Sources', 'Search Mention')")
              .w-full.h-full.px-10
                .text-center.mx-auto.mt-6.mb-2
                  Twitter.inline(width="70px" height="70px")
                h3.text-xl.font-semibold.text-center.mb-4 Search Mention
                p.text-lg.mb-4.text-center Emits new tweets matching a keyword, user, hashtag, and more.
          .max-w-md.rounded.m-1.bg-gray-800(class="md:w-1/2 sm:w-full") 
            a(href="https://pipedream.com/sources?action=create&url=https%3A%2F%2Fgithub.com%2FPipedreamHQ%2Fpipedream%2Fblob%2Fmaster%2Fcomponents%2Ftwitter%2Fmy-tweets.js&app=twitter" target="_blank" @click="logPdEvent('Sources', 'My Tweets')")
              .w-full.h-full.px-10
                .text-center.mx-auto.mt-6.mb-2
                  Twitter.inline(width="70px" height="70px")
                h3.text-xl.font-semibold.text-center.mb-4 My Tweets
                p.text-lg.mb-4.text-center Emits an event every time you tweet, with the tweet metadata
        .flex.flex-wrap.justify-around.justify-center.m-1(class="md:flex-no-wrap")
          .max-w-md.rounded.m-1.bg-gray-800(class="md:w-1/2 sm:w-full") 
            a(href="https://pipedream.com/sources?action=create&url=https%3A%2F%2Fgithub.com%2FPipedreamHQ%2Fpipedream%2Fblob%2Fmaster%2Fcomponents%2Ftwitter%2Fnew-follower-of-user.js&app=twitter" target="_blank" @click="logPdEvent('Sources', 'New Follower for User')")
              .w-full.h-full.px-10
                .text-center.mx-auto.mt-6.mb-2
                  Twitter.inline(width="70px" height="70px")
                h3.text-xl.font-semibold.text-center.mb-4 New Follower for User
                p.text-lg.mb-4.text-center Emits an event each time someone follows the handle you specify, with follower metadata
          .max-w-md.rounded.m-1.bg-gray-800(class="md:w-1/2 sm:w-full") 
            a(href="https://pipedream.com/sources?action=create&url=https%3A%2F%2Fgithub.com%2FPipedreamHQ%2Fpipedream%2Fblob%2Fmaster%2Fcomponents%2Ftwitter%2Fnew-follower-of-me.js&app=twitter" target="_blank" @click="logPdEvent('Sources', 'My New Followers')")
              .w-full.h-full.p-10
                .text-center.mx-auto.-mt-4.mb-2
                  Twitter.inline(width="70px" height="70px")
                h3.text-xl.font-semibold.text-center.mb-4 My New Followers
                p.text-lg.mb-4.text-center Emits an event each time someone follows you, with the follower metadata
        .flex.flex-wrap.justify-around.justify-center.m-1(class="md:flex-no-wrap")
          .max-w-md.rounded.m-1.bg-gray-800(class="md:w-1/2 sm:w-full") 
            a(href="https://pipedream.com/sources?action=create&url=https%3A%2F%2Fgithub.com%2FPipedreamHQ%2Fpipedream%2Fblob%2Fmaster%2Fcomponents%2Ftwitter%2Fmy-liked-tweets.js&app=twitter" target="_blank" @click="logPdEvent('Sources', 'My Liked Tweets')")
              .w-full.h-full.p-10
                .text-center.mx-auto.-mt-4.mb-2
                  Twitter.inline(width="70px" height="70px")
                h3.text-xl.font-semibold.text-center.mb-4 My Liked Tweets
                p.text-lg.mb-4.text-center Emits an event each time I like a tweet, with the tweet metadata
          .max-w-md.rounded.m-1.bg-gray-800(class="md:w-1/2 sm:w-full") 
            a(href="https://pipedream.com/sources?action=create&url=https%3A%2F%2Fgithub.com%2FPipedreamHQ%2Fpipedream%2Fblob%2Fmaster%2Fcomponents%2Ftwitter%2Ftweets-liked-by-user.js&app=twitter" target="_blank" @click="logPdEvent('Sources', 'Tweets Liked by User')")
              .w-full.h-full.px-10
                .text-center.mx-auto.mt-6.mb-2
                  Twitter.inline(width="70px" height="70px")
                h3.text-xl.font-semibold.text-center.mb-4 Tweets Liked by User
                p.text-lg.mb-4.text-center Emits an event each time a specific user likes a tweet, with the tweet metadata
        .flex.flex-wrap.justify-around.justify-center.m-1.mb-10(class="md:flex-no-wrap")
          .max-w-md.rounded.m-1.bg-gray-800(class="md:w-1/2 sm:w-full") 
            a(href="https://pipedream.com/sources?action=create&url=https%3A%2F%2Fgithub.com%2FPipedreamHQ%2Fpipedream%2Fblob%2Fmaster%2Fcomponents%2Ftwitter%2Fuser-tweets.js&app=twitter" target="_blank" @click="logPdEvent('Sources', 'New Tweets From User')")
              .w-full.h-full.p-10
                .text-center.mx-auto.-mt-4.mb-2
                  Twitter.inline(width="70px" height="70px")
                h3.text-xl.font-semibold.text-center.mb-4 New Tweets from User
                p.text-lg.mb-4.text-center Emits an event every time a specified user tweets, with the tweet metadata
          .max-w-md.rounded.m-1.bg-gray-800(class="md:w-1/2 sm:w-full") 
            a(href="https://pipedream.com/sources?action=create&url=https%3A%2F%2Fgithub.com%2FPipedreamHQ%2Fpipedream%2Fblob%2Fmaster%2Fcomponents%2Ftwitter%2Fnew-trends-by-geo.js&app=twitter" target="_blank" @click="logPdEvent('Sources', 'New Trends by Geo')")
              .w-full.h-full.p-10
                .text-center.mx-auto.-mt-4.mb-2
                  Twitter.inline(width="70px" height="70px")
                h3.text-xl.font-semibold.text-center.mb-4 New Trends by Geo
                p.text-lg.mb-4.text-center Emits an event each time a new trend occurs in a new region
        p.mb-6 Let's see how sources work with an end-to-end example:
          span.font-bold.ml-1 running code on new mentions
          | .
        p.mb-6 Most Twitter bots react to other tweets. For example, you might want to reply to a user with a specific message every time they mention you. Or you may want to store every tweet with a specific hashtag in an Amazon S3 bucket.
        p.mb-6 When you create a Twitter bot, you typically have to sign up for a Twitter developer account, create your own app, host it somewhere, and run code to poll for new tweets. This is a means to an end:
          span.font-bold.ml-1 all you really want to do is run code on new tweets
          | .
        .code.text-left.mb-6
          p // Don't care how I get tweets
          p for (const tweet of tweets) {
          p.ml-8 // Just want to run code
          p }
        p.mb-6 Pipedream lets you create a stream of tweets you can process programmatically in seconds, avoiding the app setup entirely. These are called
          a.font-bold.text-blue-500.ml-1(href="https://docs.pipedream.com/event-sources/" target="_blank") event sources
          | .
        p.mb-6 Pipedream runs the code to poll for new tweets matching your search terms, emitting them as events you can run code on.
        .mx-auto.text-center.mb-6.event-source-flow-desktop
          Twitter.mx-auto.mt-8.mb-8.inline.mr-8(height="80px" width="80px")
          ArrowLeft.inline.white.mr-8(width="25px" height="25px")
          PipedreamLogo.inline.mr-8(height="20")
          ArrowRight.inline.white.mr-4(width="25px" height="25px")
          img.inline.mr-8(src="@img/example-twitter-payload.png" width="500px" alt="Example Twitter payload")
        .mx-auto.text-center.mb-6.event-source-flow-mobile
          Twitter.mx-auto.mt-4(height="80px" width="80px")
          ArrowUp.mx-auto.white.mt-4(width="25px" height="25px")
          PipedreamLogo.mx-auto.mt-4(height="20")
          ArrowDown.mx-auto.mt-4(width="25px" height="25px")
          img.mx-auto.mt-4(src="@img/example-twitter-payload.png" width="500px" alt="Example Twitter payload")
        p.mb-6 Then, you can immediately process those tweets in a few different ways:
        ul.list-disc.mb-6
          li.ml-8.mt-4 Trigger a Pipedream workflow for each tweet, running hosted Node.js code in real time
          li.ml-8 Subscribe to a private SSE stream, which also publishes tweets in real time
          li.ml-8 Access tweets in batch using Pipedream's REST API
        p.mb-6 To get started,
          a.text-blue-500.ml-1(href="https://pipedream.com/sources?action=create&url=https%3A%2F%2Fgithub.com%2FPipedreamHQ%2Fpipedream%2Fblob%2Fmaster%2Fcomponents%2Ftwitter%2Fsearch-twitter.js&app=twitter&src=twitter.pipedream.com" target="_blank" @click="logPdEvent('CTA', 'User clicked create a new Twitter source link')") create a new Twitter search source in the Pipedream UI
          | . Name the source, connect your Twitter account, and add your search term:
        .mx-auto.max-w-3xl
          img.mb-6(src="@img/twitter-source-in-ui.png"  alt="Twitter Source in Pipedream UI")
        p.mb-6 You can also visit
          a.text-blue-500.ml-1.mr-1.break-words(href="https://pipedream.com/sources" target="_blank") https://pipedream.com/sources
          | and click the
          span.font-bold.ml-1.mr-1 Create Source
          | button, then choose the 
          span.font-mono.ml-1.mr-1 twitter/twitter-search.js
          | source from the modal that appears.
        p.mb-6 Then, you can trigger a
          a.text-blue-500.ml-1.mr-1(href="https://pipedream.com/new" target="_blank") Pipedream workflow
          | &mdash; a serverless Node.js script &mdash; on every tweet:
          .max-w-xl.mx-auto
            img.mt-6.mb-6(src="@img/new-workflow-source.png" alt="New workflow source")
        p.mb-6 or process items in your own app using
          a.text-blue-500.ml-1.mr-1(href="#apis") the SSE stream or REST API
          | tied to your source.
      p.mb-24(id="apis")
      .max-w-5xl.mx-auto.text-left.ml-10.mr-10.text-xl
        p.text-green.text-3xl.font-bold.mb-6 SSE and REST APIs
        p.mb-6 Pipedream provides two other interfaces for accessing events produced by sources: 
        ul.list-disc.mb-6
          li.ml-8.mt-4 A private SSE stream specific to your source
          li.ml-8 A REST API
        p.mb-12 This way, you can run an event source in Pipedream but access its events in your own application.
        p.font-bold.mb-6.text-2xl(id="sse-interface") SSE
        p.mb-6 SSE &mdash;
          a.text-blue-500.ml-1.mr-1(href="https://developer.mozilla.org/en-US/docs/Web/API/Server-sent_events" target="_blank") Server-sent events
          | &mdash;
          span.ml-1 defines a spec for how servers can send events directly to clients that subscribe to those events, similar to
          a.text-blue-500.ml-1(href="https://developer.mozilla.org/en-US/docs/Web/API/WebSockets_API" target="_blank") WebSockets 
          | and related server-to-client push technologies. If you listen for new items using SSE, 
          span.font-bold you can run any code in your own application, in real time, as soon as those items are added to the feed.
        p.mb-6 Streams are private by default. You authenticate by passing your Pipedream API key in the Authorization header:
        .code.text-left.px-10.mb-6.break-words
          p $ curl -H "Authorization: Bearer API_KEY" \
          p.ml-10 https://api.pipedream.com/sources/SOURCE_ID/sse
        p.mb-12
          a.text-blue-500.mr-1(href="https://docs.pipedream.com/api/sse" target="_blank") See the Pipedream SSE docs 
          | for more information on authentication, example Node code, and other details on the interface.
        p.font-bold.mb-6.text-2xl(id="rest-api") REST API
        p.mb-6 If you prefer to process tweets in batch, you can fetch them using 
          a.text-blue-500.ml-1(href="https://docs.pipedream.com/api/rest/" target="_blank") Pipedream's REST API
          | :
        .code.text-left.px-10.mb-6.break-words
          p $ curl -H "Authorization: Bearer API_KEY" \
          p.ml-10 https://api.pipedream.com/v1/sources/SOURCE_ID/event_summaries?limit=1
        p.mb-6 Note the
          span.font-mono.ml-1.mr-1 ?limit=1
          | query string. You can vary the number of events returned (most recent first) by setting this param.
      .max-w-5xl.mx-auto.text-left.ml-10.mr-10.text-xl.mt-24
        p.text-green.font-bold.mb-3.text-3xl Questions or Feedback?
        p.mb-6 Please
          a.text-blue-500.ml-1.mr-1(href="https://docs.pipedream.com/support/" target="_blank") reach out
          | with any questions or feedback. We're happy to add other Twitter-specific developer resources to this list, and we'd love to hear what can be improved about event sources or the example workflows.
        .mt-24.mb-24
          hr.border-gray-500.border
          .pt-12.flex.flex-wrap.justify-start
            .flex-start(class="md:w-1/3 sm:flex-wrap")
              p.text-sm.text-gray-500 Pipedream, Inc. &mdash; San Francisco, CA
            .ml-auto(class="md:w-1/8 sm:flex-wrap")
              a.text-sm.text-blue-500(@click="logPdEvent('Footer', 'User Clicked Twitter link')" href="https://twitter.com/pipedream" target="_blank") Twitter
            .ml-6(class="md:w-1/8 sm:flex-wrap")
              a.text-sm.text-blue-500(@click="logPdEvent('Footer', 'User Clicked Community link')" href="https://pipedream.com/community" target="_blank") Community
            .ml-6(class="md:w-1/8 sm:flex-wrap")
              a.text-sm.text-blue-500(@click="logPdEvent('Footer', 'User Clicked Docs link')" href="https://docs.pipedream.com/" target="_blank") Docs
            .ml-6(class="md:w-1/8 sm:flex-wrap")
              a.text-sm.text-blue-500(@click="logPdEvent('Footer', 'User Clicked Terms link')" href="https://pipedream.com/terms" target="_blank") Terms
            .ml-6(class="md:w-1/8 sm:flex-wrap")
              a.text-sm.text-blue-500(@click="logPdEvent('Footer', 'User Clicked Privacy link')" href="https://pipedream.com/privacy" target="_blank") Privacy
</template>

<script>
import ArrowDown from "@icons/arrow-down.svg?inline";
import ArrowLeft from "@icons/arrow-left.svg?inline";
import ArrowRight from "@icons/arrow-right.svg?inline";
import ArrowUp from "@icons/arrow-up.svg?inline";
import Bell from "@icons/bell.svg?inline";
import Browser from "@icons/browser.svg?inline";
import Clock from "@icons/clock.svg?inline";
import Code from "@icons/code.svg?inline";
import DeviceMobile from "@icons/device-mobile.svg?inline";
import Heart from "@icons/heart.svg?inline";
import Mail from "@icons/mail.svg?inline";
import PipedreamIcon from "@icons/pipedream.svg?inline";
import RSSIcon from "@icons/rss.svg?inline";
import Server from "@icons/server.svg?inline";
import Terminal from "@icons/terminal.svg?inline";

import Browserless from "@logos/browserless.svg";
import Discord from "@logos/discord.svg?inline";
import EventBridge from "@logos/eventbridge.svg?inline";
import Lambda from "@logos/lambda.svg?inline";
import PipedreamLogo from "@logos/pipedream.svg?inline";
import RSS from "@logos/rss.svg?inline";
import S3 from "@logos/s3.svg?inline";
import Slack from "@logos/slack.svg?inline";
import SQL from "@logos/sql.svg?inline";
import SQS from "@logos/sqs.svg?inline";
import Telegram from "@logos/telegram.svg?inline";
import Twitter from "@logos/twitter.svg?inline";
import Webhook from "@logos/webhook.svg?inline";

import { logPipedreamEvent } from "@plugins/analytics";

export default {
  name: "Main",
  props: {
    title: String
  },
  components: {
    ArrowDown,
    ArrowLeft,
    ArrowRight,
    ArrowUp,
    Bell,
    Browser,
    Browserless,
    Clock,
    Code,
    DeviceMobile,
    Discord,
    EventBridge,
    Heart,
    Lambda,
    Mail,
    PipedreamIcon,
    PipedreamLogo,
    RSS,
    RSSIcon,
    S3,
    Server,
    Slack,
    SQL,
    SQS,
    Telegram,
    Terminal,
    Twitter,
    Webhook
  },
  created: function() {
    logPipedreamEvent({
      category: "INIT",
      action: "Page Load"
    });
  },
  methods: {
    logPdEvent: function(category, action) {
      logPipedreamEvent({
        category,
        action
      });
    }
  }
};
</script>

<style scoped>
.pd-green {
  background-color: #34d28b;
}
.text-green {
  color: #34d28b;
}

/* SVG classes */

.st0 {
  fill: #e01e5a;
}
.st1 {
  fill: #36c5f0;
}
.st2 {
  fill: #2eb67d;
}
.st3 {
  fill: #ecb22e;
}
.cls-1 {
  fill: #ff4f8b;
}
.cls-2 {
  fill: #232f3e;
}

.lambda-cls-1 {
  fill: #f90;
}

.twitter-cls-1 {
  fill: none;
}

.twitter-cls-2 {
  fill: #1da1f2;
}

.s3-cls-1 {
  fill: #6cae3e;
}

.button {
  stroke: none;
  fill: orange;
}
.symbol {
  stroke: none;
  fill: white;
}

.discord-st0 {
  fill: #ffffff;
}
.rollbar-st0 {
  fill: #ffffff;
}

@media screen and (max-width: 1200px) {
  .event-source-flow-desktop {
    visibility: hidden;
    height: 0;
    padding: 0;
    margin-bottom: 1rem;
  }
}

@media screen and (min-width: 1200px) {
  .event-source-flow-mobile {
    visibility: hidden;
    height: 0;
    padding: 0;
    margin-bottom: 1rem;
  }
}

.header {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  background-color: rgba(34, 34, 34, 0.85);
}

.code {
  @apply font-mono py-10 px-10 rounded;
  background-color: #000000;
}

@media screen and (max-width: 640px) {
  .code {
    @apply text-base px-3 py-5;
  }
}

.title {
  line-height: 1.162;
}
.introducing-title {
  letter-spacing: 0.85vw;
}
</style>
